"use client";

import { useState, useEffect, createContext, useContext } from "react";
import { MegaMenuProvider } from "./MegaMenuContext";
import { MegaMenu } from "./MegaMenu";
import type { TransformedNavData } from "@/lib/navigation-utils";

const NavCollapsedContext = createContext(false);
export const useNavCollapsed = () => useContext(NavCollapsedContext);

interface ScrollableHeaderProps {
  navData: NonNullable<TransformedNavData>;
  children: React.ReactNode;
}

export function ScrollableHeader({ navData, children }: ScrollableHeaderProps) {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkDesktop = () => setIsDesktop(window.innerWidth >= 1280);
    checkDesktop();
    window.addEventListener("resize", checkDesktop);
    return () => {
      window.removeEventListener("resize", checkDesktop);
    };
  }, []);

  // Nav is locked to its compact state for now. The expand-on-load / expand-on-hover
  // animation is preserved below — uncomment the block to restore the original
  // scroll- and hover-driven behaviour.
  const collapsed = true;

  /*
  // --- Original expand/collapse behaviour (kept for future use) ---
  // const [scrollProgress, setScrollProgress] = useState(0);
  // const [isHovered, setIsHovered] = useState(false);
  //
  // useEffect(() => {
  //   const checkScroll = () => {
  //     const progress = Math.min(window.scrollY / 400, 1);
  //     setScrollProgress(progress);
  //   };
  //   checkScroll();
  //   window.addEventListener("scroll", checkScroll, { passive: true });
  //   return () => window.removeEventListener("scroll", checkScroll);
  // }, []);
  //
  // const collapsed = scrollProgress > 0.3 && !isHovered;
  //
  // Wrapper props used originally:
  //   style={{
  //     backgroundColor: `rgba(0, 0, 0, ${scrollProgress * 0.8})`,
  //     backdropFilter: `blur(${scrollProgress * 12}px)`,
  //     WebkitBackdropFilter: `blur(${scrollProgress * 12}px)`,
  //   }}
  //   onMouseEnter={() => setIsHovered(true)}
  //   onMouseLeave={() => setIsHovered(false)}
  */

  return (
    <NavCollapsedContext.Provider value={collapsed}>
      <div className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md">
        <MegaMenuProvider items={navData.navItems}>
          <div>
            {children}
          </div>

          {isDesktop && <MegaMenu />}
        </MegaMenuProvider>
      </div>
    </NavCollapsedContext.Provider>
  );
}
